module.exports = __webpack_public_path__ + "static/img/8500GM.8126240c.png";